/**
 * Post a message to a native iOS WKWebView handler when the bridge is available.
 * No-ops safely in Safari/Chrome (no Capacitor / no custom WebView).
 */
export function postToIosNative(handlerName, payload = {}) {
  if (typeof window === 'undefined' || !handlerName) {
    return false
  }

  const handler = window.webkit?.messageHandlers?.[handlerName]
  if (!handler || typeof handler.postMessage !== 'function') {
    return false
  }

  try {
    handler.postMessage(payload)
    return true
  } catch {
    return false
  }
}

export function hasIosNativeBridge(handlerName) {
  if (typeof window === 'undefined' || !handlerName) {
    return false
  }
  const handler = window.webkit?.messageHandlers?.[handlerName]
  return Boolean(handler && typeof handler.postMessage === 'function')
}

const noopHandler = { postMessage: () => {} }

/**
 * Safari exposes `window.webkit` without `messageHandlers` outside a native WebView.
 * Legacy scripts that read `window.webkit.messageHandlers.*` throw; stub handlers on web.
 */
export function patchWebkitMessageHandlersForWeb() {
  if (typeof window === 'undefined' || import.meta.env.VITE_MOBILE_APP) {
    return
  }

  const webkit = window.webkit
  if (!webkit || webkit.messageHandlers) {
    return
  }

  webkit.messageHandlers = new Proxy(
    {},
    {
      get() {
        return noopHandler
      }
    }
  )
}
